import { render, staticRenderFns } from "./plan_mobile_new.vue?vue&type=template&id=b7bf73ec&"
import script from "./plan_mobile_new.vue?vue&type=script&lang=js&"
export * from "./plan_mobile_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports